import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import IconButton from '~/common/components/Icons/IconButton';
import { SNAPSHOT_BUTTON_LABEL } from '~/common/constants';

import { setCitation } from './../../utils/utils';

type SnapShotButtonProps = {
  snippets?: any[];
  questionName?: string;
};

/**
 * @typedef {object} SnapShotButtonProps
 * @property {import('./../../types/smartAnswers').Snippet[]} [snippets=[]] - The snippets to take a snapshot of.
 * @property {string} questionName - The name of the question.
 *
 * @param {SnapShotButtonProps} props
 * @returns {JSX.Element}
 */
export default function SnapShotButton({
  snippets = [],
  questionName = '',
}: Readonly<SnapShotButtonProps>) {
  if (snippets.length === 0) {
    return null;
  }
  return (
    <IconButton
      aria-label={SNAPSHOT_BUTTON_LABEL}
      data-testid={`${questionName}-snapshot-button`}
      onClick={() => {
        setCitation(snippets);
      }}
      bg="white"
      color="blue.600"
      borderColor="blue.600"
      border="2px solid"
      borderRadius="0.5rem"
    >
      <FontAwesomeIcon icon={faCamera} />
    </IconButton>
  );
}
